import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import tinyMceCustomPluginsUtils from "@/components/tinyMce/plugins/tinyMceCustomPluginsUtils";
import GridLayout from "@/components/layout/GridLayout.vue";
let EditorViewer = class EditorViewer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "htmlContent", void 0);
    _defineProperty(this, "formattedHtmlContent", '');
    _defineProperty(this, "activeCustomPlugins", null);
  }
  mounted() {
    this.formatContentToDisplay();
  }
  onHtmlContentChange() {
    this.formatContentToDisplay();
  }
  formatContentToDisplay() {
    if (this.htmlContent) {
      const iframe = this.$refs.editorViewer;
      if (iframe) {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
          this.activeCustomPlugins = tinyMceCustomPluginsUtils.handleActiveCustomPluginsStates(this.htmlContent);
          this.formattedHtmlContent = "<style> body { font-family: 'Nunito Sans', sans-serif, Avenir, Helvetica, Arial sans-serif; padding: 8px 50px;} </style>" + tinyMceCustomPluginsUtils.applyViewModeTransformation(this.htmlContent, this.activeCustomPlugins, this.$i18n.locale.toLowerCase(), iframeDoc);
          setTimeout(() => {
            this.resizeIframeAndLoadCustomPluginsAssets();
          }, 100);
        }
      }
    }
  }
  resizeIframeAndLoadCustomPluginsAssets() {
    const iframe = this.$refs.editorViewer;
    if (!iframe) return;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc || !this.activeCustomPlugins) return;
    if (this.activeCustomPlugins) {
      tinyMceCustomPluginsUtils.loadViewModeAssets(this.activeCustomPlugins, iframeDoc);
      tinyMceCustomPluginsUtils.enablePluginsViewerModeEvents(this.activeCustomPlugins, iframeDoc);
    }
  }
};
__decorate([Prop({
  required: true
})], EditorViewer.prototype, "htmlContent", void 0);
__decorate([Watch("htmlContent")], EditorViewer.prototype, "onHtmlContentChange", null);
EditorViewer = __decorate([Component({
  components: {
    GridLayout
  }
})], EditorViewer);
export default EditorViewer;